import { CenteredSquaredContainer, FullscreenImageLayout } from 'ui-components';
import { PropsWithChildren } from 'react';

type Props = PropsWithChildren<{
  src: string;
}>;

export function BookingLayout({ src, children }: Props): JSX.Element {
  return (
    <FullscreenImageLayout src={src}>
      <CenteredSquaredContainer>{children}</CenteredSquaredContainer>
    </FullscreenImageLayout>
  );
}
